import { useScrollReveal } from "../../../hooks/useScrollReveal";

interface GalleryImageProps {
  src: string;
  alt: string;
  index: number;
  total: number;
  onClick: () => void;
}

export default function GalleryImage({
  src,
  alt,
  index,
  total,
  onClick,
}: GalleryImageProps) {
  const ref = useScrollReveal<HTMLButtonElement>({
    delay: (index % 4) * 100,
    direction: "up",
    distance: 32,
    duration: 750,
  });

  return (
    <button
      ref={ref}
      onClick={onClick}
      className="group relative w-full aspect-[3/2] rounded-lg overflow-hidden cursor-pointer ring-1 ring-transparent hover:ring-teal/25 transition-all duration-300"
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/25 transition-colors duration-300 flex items-center justify-center">
        <span className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <i className="ri-zoom-in-line text-xl text-white" />
          <span className="font-sans text-[10px] uppercase tracking-[2px] text-white/90">
            {index + 1} / {total}
          </span>
        </span>
      </div>
      <div className="absolute bottom-0 left-0 w-full h-0 group-hover:h-1 bg-teal/60 transition-all duration-300" />
    </button>
  );
}